import { createFileRoute } from "@tanstack/react-router"
import SalesOperations from "~/pages/sales-operations"
import { usePageTracking } from "~/hooks/usePageTracking"

export const Route = createFileRoute("/_auth/insights/")({
  component: RouteComponent,
})

function RouteComponent() {
  usePageTracking("Sales & Operations")
  return <SalesOperations />
}
